<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Búsqueda de códigos</h3>
    <button (keydown.tab)="onNexFocus()" tabindex="401" type="button" class="close" aria-label="Close" (click)="cancelar()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <button type="button" class="btn btn-rounded btn-warning" tabindex="402" (click)="cancelar()" (keydown.tab)="onNexFocus()"><i
        class="fa fa-times-circle"></i> Cancelar
    </button>
    
    <br>


    <div tabindex="95" name="codArticuloI" #codArticuloI id="codArticuloI" class="table-responsive">
        <table id="datatableArtCodCla" class="table table-striped table-bordered table-sm row-border hover nowrap"  style="width: 100%;">
                    <thead>
                        <tr>
                            <th> Código </th>
                            <th class="text-left"> Descripción </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="cursor" *ngFor="let lst of clasesCodigos; index as i"
                            [ngClass]="{'nombre-de-la-clase': lst == this.lsttemp}"
                             (click)="onClick(lst)">
                            <td>{{lst.codigo}}</td>
                            <td class="text-left">{{lst.descri}}</td>
                        </tr>
                    </tbody>
        </table>
    </div>
</div>
